import { ReactElement } from "react";
import { Button } from "@justworkshr/milo-core";

import { getEnvVariables } from "lib/environment";

import FooterButtons from "global-components/footerButtons/FooterButtons";

import styles from "./confirmation.module.css";

const Confirmation = ({
  email,
  onClickBack,
}: {
  email: string;
  onClickBack: () => void;
}): ReactElement => {
  return (
    <>
      <p className={styles.message}>
        Got it. If your email address <b>{email}</b> is registered with
        Justworks, we'll email you the associated usernames.
      </p>

      <FooterButtons>
        <Button variant={"ghost"} onClick={onClickBack}>
          Back
        </Button>
        <Button
          type="submit"
          variant="filled"
          as="a"
          className={styles.filledButtonLinkFix}
          href={getEnvVariables().oktaHostUrl}
        >
          Go to login
        </Button>
      </FooterButtons>
    </>
  );
};

export default Confirmation;
